module.exports = __webpack_public_path__ + "img/operationCapacity3.5c9f7b8c.png";